
































































































































































































import gql from 'graphql-tag'
import { Component, Mixins } from 'vue-property-decorator'

import { feedIndexStore, logEvent } from '@/common'
import AppAlertView from '@/components/AppAlertView.vue'
import AppHlsVideo from '@/components/AppHlsVideo.vue'
import AppRouterLink from '@/components/AppRouterLink.vue'
import CommentsModal from '@/components/CommentsModal.vue'
import FeedItemsModal from '@/components/FeedItemsModal.vue'
import PopupBannerModal from '@/components/PopupBannerModal.vue'
import VideoPlayer from '@/components/VideoPlayer.vue'
import { analytics } from '@/firebase'
import { CURRENT_USER } from '@/gql/auth'
import { SHOW_LOGIN_MODAL } from '@/gql/misc'
import { User } from '@/mixins'

const FEED_FRAGMENT = gql`
fragment FeedFragment on Feed {
  id
  commentCount
  title
  text
  isSaved @client
  saveCount
  isActive
  itemCount
  viewCount
  medias {
    id
    path
    subMedias {
      id
      path
      type
      ownerUseType
    }
  }
  firstItem {
    id
    medias {
      id
      path
    }
  }
  user {
    id
    username
    displayName
    isSubscribed @client
  }
  tags {
    id
    name
  }
}`

@Component({
  components: {
    AppAlertView,
    AppHlsVideo,
    AppRouterLink,
    CommentsModal,
    FeedItemsModal,
    PopupBannerModal,
    VideoPlayer
  },
  metaInfo () {
    const feeds = (this as any).mainPageFeedConnection.feeds
    if (feeds.length !== 1) return {}
    const feed: { text: string; tags: { name: string }[]; title: string; id: string } = feeds[0]

    const content = `${feed.text || ''}`.trim().substring(0, 160).replace(/\n/g, ' ') + ` ${feed.tags.map(tag => '#' + tag.name).join(' ')}`
    return {
      meta: [
        { name: 'description', content },
        { property: 'og:description', content },
        { property: 'og:title', content: `${feed.title} - 페퍼로니` },
        { property: 'og:image', content: (this as any).posterUrl(feed) },
        { property: 'og:url', content: location.origin + location.pathname },
        { property: 'al:ios:url', content: `pepperoni://feeds/${feed.id}` }
      ]
    }
  },
  apollo: {
    currentUser: {
      query: CURRENT_USER
    },
    user: {
      query: gql`query userAtFeeds($targetUserId: Int) {
        user(targetUserId: $targetUserId) {
          id
          media {
            id
            path
          }
        }
      }`,
      variables () {
        return {
          targetUserId: +this.currentUser.id
        }
      },
      skip () {
        return !this.currentUser
      }
    },
    mainPageFeedConnection: {
      query: gql`query mainPageFeedConnection($after: String, $refresh: Boolean) {
        mainPageFeedConnection(first: 20, after: $after, refresh: $refresh) {
          cursor
          hasNextPage
          feeds {
            ...FeedFragment
          }
        }
      }
      ${FEED_FRAGMENT}`,
      skip () {
        return !!this.$route.params.id
      },
      variables () {
        return {
          // after: localStorage.getItem('mainPageFeedConnectionCursor'),
          refresh: true
        }
      },
      manual: true,
      result ({ data }) {
        const feedIdSet = new Set<string>()
        const feeds: { id: string }[] = []

        data.mainPageFeedConnection.feeds.forEach((feed: { id: string }) => {
          if (!feedIdSet.has(feed.id)) {
            feedIdSet.add(feed.id)
            feeds.push(feed)
          }
        })
        this.mainPageFeedConnection = {
          ...data.mainPageFeedConnection,
          feeds
        }
      }
    },
    getFeedByFeedId: {
      query: gql`query ($feedId: Int!) {
        getFeedByFeedId(feedId: $feedId) {
          ...FeedFragment
        }
      }
      ${FEED_FRAGMENT}`,
      skip () {
        return !this.$route.params.id
      },
      variables () { return { feedId: +this.$route.params.id } },
      manual: true,
      async result ({ data }) {
        document.title = `${data.getFeedByFeedId.title} - 페퍼로니`
        this.mainPageFeedConnection = { feeds: [data.getFeedByFeedId] }
      }
    },
    playAudio: {
      query: gql`query { playAudio @client }`,
      result ({ data }) { this.muted = !data.playAudio }
    }
  }
})
export default class extends Mixins(User) {
  currentUser: { id: string } | null = null
  user = {}
  mainPageFeedConnection: {
    hasNextPage: boolean;
    cursor: string;
    feeds: { id: string }[];
  } = { hasNextPage: false, cursor: '', feeds: [] }

  feedIndex = -1
  feedIndexForUi = -1
  fetchMoreInProgress = false
  commentsModalFeedId: string | null = null
  fromFeedId = ''
  bodyExpanded: boolean[] = []
  showControls: boolean[] = []
  isVideoVisible: boolean[] = []
  paused: boolean[] = []
  playAudio = false
  muted = true
  feedShowMore: { id: string; user: { id: string } } | null = null

  now = Date.now()
  isGuideActive = false
  isSideTipActive = false
  isPopupBannerModalActive = false

  seekTime: number[] = []
  duration: number[] = []
  time: number[] = []
  seeking = false

  showTapBackward = false
  showTapForward = false
  dragging = false
  tapTime = 0
  tapTimeout = 0
  tapForwardTimeout = 0
  tapBackwardTimeout = 0

  onHlsVideoTime (t: number, index: number) {
    if (this.seeking) return
    this.$set(this.time, index, t)

    const startTime = +this.$route.query.startTime / 1000.0
    const endTime = +this.$route.query.endTime / 1000.0
    if (endTime && (t < +startTime || t > +endTime)) {
      (this.$refs.appHlsVideo as any)[0].onSeekTimeChanged(startTime)
    }
  }

  onTap (event: Event, isForward: boolean, index: number) {
    if (this.dragging) return
    event.preventDefault()
    const curTime = new Date().getTime()
    const doubleTapDetected = curTime - (this.tapTime * (isForward ? 1 : -1)) < 300

    if (doubleTapDetected) {
      this.$set(this.seekTime, index, (this.time[index] || 0) + 10 * (isForward ? 1 : -1))
      if (isForward) {
        this.showTapForward = true
        clearTimeout(this.tapForwardTimeout)
        this.tapForwardTimeout = window.setTimeout(() => { this.showTapForward = false }, 800)
      } else {
        this.showTapBackward = true
        clearTimeout(this.tapBackwardTimeout)
        this.tapBackwardTimeout = window.setTimeout(() => { this.showTapBackward = false }, 800)
      }
    }

    clearTimeout(this.tapTimeout)

    if (doubleTapDetected) {
      this.tapTime = 0
    } else {
      this.tapTime = isForward ? curTime : -curTime
      this.tapTimeout = window.setTimeout(() => {
        this.onClickVideo(index)
      }, 300)
    }
  }

  async mounted () {
    const feedIndex = feedIndexStore[history.state.key]
    if (feedIndex) {
      const ele = document.getElementById(`feed-${feedIndex}`)
      if (ele) {
        ele.scrollIntoView()
      }
    }

    this.isPopupBannerModalActive = !this.$route.params.id && this.now / 1000 > +(localStorage.getItem('mutePopupBannerUntil') || 0)
    this.isGuideActive = !this.isPopupBannerModalActive && !localStorage.getItem('isFeedViewGuideDismissed')
    this.isSideTipActive = !this.isGuideActive && !localStorage.getItem('isFeedViewSideTipDismissed')
  }

  onDismissPopupBanner () {
    this.isPopupBannerModalActive = false
    this.isGuideActive = !localStorage.getItem('isFeedViewGuideDismissed')
    this.isSideTipActive = !this.isGuideActive && !localStorage.getItem('isFeedViewSideTipDismissed')
  }

  onClickGuide () {
    localStorage.setItem('isFeedViewGuideDismissed', 'true')
    this.isGuideActive = false
    this.isSideTipActive = !localStorage.getItem('isFeedViewSideTipDismissed')
  }

  onClickSideTip () {
    localStorage.setItem('isFeedViewSideTipDismissed', 'true')
    this.isSideTipActive = false
  }

  onClickFeedItem (feedId: string) {
    this.fromFeedId = feedId
    this.onClickSideTip()
  }

  async sendUserFeedReaction () {
    const duration = Date.now() - this.now
    this.now = Date.now()

    if (duration >= 1000 && this.feedIndex >= 0) {
      const feed = this.mainPageFeedConnection.feeds[this.feedIndex]
      await this.$apollo.mutate({
        mutation: gql`mutation ($input: UserFeedReactionInput!) {
          sendUserFeedReaction(input: $input) {
            id
          }
        }`,
        variables: {
          input: {
            feedId: feed.id,
            retentions: duration / 1000,
            openItem: false,
            openContents: false,
            playedAt: 0,
            reactedItemId: -1,
            reactedFeedId: -1
          }
        }
      })
    }
  }

  async beforeDestroy () {
    await this.sendUserFeedReaction()
  }

  placeholderVisibilityChanged (isVisible: boolean, feedIndex: number) {
    if (isVisible) {
      this.feedIndexForUi = feedIndex
    }
  }

  visibilityChanged (isVisible: boolean, feedIndex: number) {
    if ((this.isVideoVisible[feedIndex] || false) !== isVisible) {
      this.$set(this.isVideoVisible, feedIndex, isVisible)
    }
    if (!isVisible || this.feedIndex === feedIndex) return

    this.sendUserFeedReaction()

    const feed = this.mainPageFeedConnection.feeds[feedIndex];
    (async () => {
      await logEvent('select_content', { item_id: feed.id, content_type: 'feed' })
      if (analytics) {
        await this.logAppsflyerEvent('af_content_view', {
          af_content_id: feed.id,
          af_content_type: 'feed'
        })
      }
    })().catch(e => console.error(e))

    if (navigator.userAgent.includes('Mac OS') || navigator.userAgent.includes('iPhone')) {
      this.muted = true
    }

    feedIndexStore[history.state.key] = feedIndex
    this.feedIndex = feedIndex

    if (
      !this.mainPageFeedConnection.hasNextPage ||
      this.fetchMoreInProgress ||
      feedIndex + 3 < this.mainPageFeedConnection.feeds.length
    ) return

    this.fetchMoreInProgress = true

    this.$apollo.queries.mainPageFeedConnection.fetchMore({
      variables: { after: this.mainPageFeedConnection.cursor, refresh: false },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.fetchMoreInProgress = false

        return {
          mainPageFeedConnection: {
            ...fetchMoreResult.mainPageFeedConnection,
            feeds: [
              ...previousResult.mainPageFeedConnection.feeds,
              ...fetchMoreResult.mainPageFeedConnection.feeds
            ]
          }
        }
      }
    }).catch(e => e.name !== 'Invariant Violation' && console.error(e))
  }

  async onClickVideo (index: number) {
    this.$set(this.showControls, index, !this.showControls[index])

    if (this.muted && !this.playAudio) {
      this.muted = false
      if (navigator.userAgent.includes('Chrome')) {
        await this.$apollo.mutate({
          mutation: gql`mutation {
            setPlayAudio @client
          }`
        })
      }
    }
  }

  posterUrl (feed: { medias: { subMedias: { ownerUseType: string; path: string }[] }[] }) {
    const media = feed.medias[0].subMedias.find(media => media.ownerUseType === 'FEED_JPG_BIG')
    return media ? media.path : ''
  }

  isMyFeed (feed: { user: { id: string } }) {
    return (this.currentUser && this.currentUser.id === feed.user.id)
  }

  async onClickSubscription (userId: string, name: string, isSubscribed: boolean) {
    if (!this.currentUser) {
      await this.$apollo.mutate({ mutation: SHOW_LOGIN_MODAL })
    } else {
      await this.toggleSubscription(this.currentUser.id, userId, name, isSubscribed)
    }
  }

  get alertActions () {
    const actions = [{ text: '링크 공유하기', warning: false }]
    if (this.feedShowMore && this.isMyFeed(this.feedShowMore)) {
      actions.push({ text: '스토리 삭제', warning: true })
    }
    return actions
  }

  async onActionAlertView (index: number) {
    if (!this.feedShowMore) return

    const feed = this.feedShowMore
    if (index === 0) {
      this.shareLocation(`feed-${feed.id}`, `${process.env.VUE_APP_WEB_ORIGIN}/feeds/${feed.id}`)
    } else if (index === 1) {
      const result = confirm('스토리를 삭제하시겠습니까?')
      if (!result) return

      const { data } = await this.$apollo.mutate({
        mutation: gql`mutation ($feedId: ID!) {
          deleteFeed(feedId: $feedId) {
            success
            message
          }
        }`,
        variables: { feedId: feed.id }
      })
      await this.showToast(data.deleteFeed.message)
      this.evictApolloCache(`createdFeedConnection({"userId":${feed.user.id}})`)
      if (this.$route.params.id) {
        this.$router.back()
      } else {
        await this.$apollo.queries.mainPageFeedConnection.refetch()
      }
    }

    this.feedShowMore = null
  }

  async onClickSaveFeed (feed: {
    id: string;
    medias: { subMedias: { type: string; ownerUseType: string; path: string }[] }[];
    isSaved: boolean;
  }) {
    if (!this.currentUser) {
      await this.$apollo.mutate({ mutation: SHOW_LOGIN_MODAL })
      return
    }

    const thumbnailImagePath = (() => {
      if (feed.medias.length === 0) {
        return ''
      }
      const subMedia = feed.medias[0].subMedias.find(media =>
        media.type === 'IMAGE' && media.ownerUseType === 'FEED_JPG_SMALL')
      if (subMedia) {
        return subMedia.path
      } else {
        return ''
      }
    })()

    await this.$apollo.mutate({
      mutation: gql`mutation ($input: SaveFeedInput!) {
        saveFeedClient(input: $input) @client {
          id
          isSaved
        }
      }`,
      variables: {
        input: {
          feedId: feed.id,
          thumbnailImagePath,
          save: !feed.isSaved
        }
      }
    })

    if (!feed.isSaved) {
      if (analytics) {
        await this.logAppsflyerEvent('af_add_to_wishlist', {
          af_content_type: 'feed',
          af_content_id: feed.id
        })
      }
    }
  }

  async leaveComment () {
    this.commentsModalFeedId = this.$route.params.id
    await this.$nextTick()
    await (this.$refs.commentsModal as CommentsModal).reset()
  }
}
